import { DEEP } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

export default function DeepDive() {
  return (
    <section id="deep" className="bg-background-100">
      <div className="mx-auto max-w-[1240px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="独家深扒 · 连载出品"
          title="不是一句瓜，是一整条瓜线"
          desc="有证可查的部分我们摊开讲，证不了的部分也老实标注，不和稀泥。"
        />

        <div className="space-y-6">
          {DEEP.map((d, i) => (
            <article
              key={d.title}
              className="group grid grid-cols-1 gap-0 overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200/70 lg:grid-cols-2"
            >
              <div className={`overflow-hidden ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <a href="#report" className="block h-full overflow-hidden">
                  <img
                    src={d.img}
                    alt={`海角天崖独家深扒 ${d.title}`}
                    className="h-[240px] w-full object-cover object-top transition-transform duration-500 group-hover:scale-105 md:h-[300px]"
                  />
                </a>
              </div>
              <div className="flex flex-col justify-center p-5 md:p-8">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="rounded-md bg-accent-500 px-2 py-0.5 text-[12px] font-bold text-foreground-950">
                    {d.kicker}
                  </span>
                  <span className="text-[12px] text-foreground-500">连载 {d.series}</span>
                </div>
                <h4 className="mt-3 font-heading text-[20px] font-black leading-snug text-foreground-950 md:text-[24px]">
                  <a href="#report">{d.title}</a>
                </h4>
                <p className="mt-3 text-[14px] font-medium leading-6 text-foreground-800">{d.lead}</p>
                <p className="mt-2 text-[13px] leading-6 text-foreground-600">{d.body}</p>
                <div className="mt-5 flex flex-wrap items-center gap-3">
                  <a
                    href="#report"
                    className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-[14px] font-bold text-background-50 transition-colors hover:bg-primary-700"
                  >
                    展开完整时间线
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
                  </a>
                  <span className="flex items-center gap-1.5 text-[13px] text-foreground-500">
                    <i className="ri-eye-line w-4 h-4 flex items-center justify-center" />
                    {d.reads} 人读完
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}